import Highcharts from 'highcharts';

export default class ChartService
{
	constructor(AppService, DateRangeService)
	{
		this.AppService = AppService;
		this.DateRangeService = DateRangeService;

		this.baseData = null;
		this.compareData = null;

		this.chartType = null;

		this.settings = {
			chart: {
				style: {
					fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
					fontWeight: 'normal'
				},
				type: 'line',
				animation: {
					duration: 0
				}
			},
			credits: {
				enabled : false
			},
			title: {
				text: ''
			},
			plotOptions: {
				color: '#2199E9',
				line: {
				    dataLabels: {
				        enabled: true
				    }
				},
				series: {
					animation: false
				}
			},
			tooltip: {
				shared: false,
				formatter: function() {
					var text = '';
					if (this.series.index == 0) {
						if (this.x === null) {
							var x = 'Unknown';
						} else {
							var x = this.x;
						}
						text = x + '<br/> <strong>' + this.y + '</strong>';
					} else {
						text = this.key + '<br/> <strong>' + this.y + '</strong>';
					}
					return text;
				}
			},
			xAxis: {
				categories: [{}]
			},
			yAxis: {
				title: {
					text: ''
				}
			},
			series: [{}]
		};
	}

	create(id) {
		// Highcharts.setOptions();
		this.$element = $('#'+id);

		let chartType = this.$element.data('chart-type');

		this.chartType = chartType;
		this.settings.chart.type = chartType;

		this.$element = Highcharts.chart(id, this.settings);
	}

	createOverview() {
		this.settings.chart.type = $('#overview-chart').data('chart-type');
		this.$overviewElement = Highcharts.chart('overview-chart', this.settings);
	}

	updateOverviewBaseData(data) {
		let categories = [];
		let volume = [];

		for (let row of data) {
			let category = row[0];
			if (row[0] === null) {
				category = 'Unknown';
			}
			categories.push(category);
			volume.push(row[1]);
		}

		this.$overviewElement.xAxis[0].update({
			categories: categories
		}, true);

		this.$overviewElement.series[0].update({
			name: this.DateRangeService.startDate.format('DD/MM/YYYY') + ' - ' + this.DateRangeService.endDate.format('DD/MM/YYYY'),
			data: volume
		}, true);

		// If compare date range is unchecked
		if (!this.AppService.compare && this.$overviewElement.series.length == 2) {
			this.$overviewElement.series[1].remove(true);
		}

		this.$overviewElement.setSize(800, 500, true);
		this.$overviewElement.redraw();
		window.dispatchEvent(new Event('resize'));
	}

	updateOverviewCompareData(data) {
		if (this.$overviewElement.series.length == 1) {
			this.$overviewElement.addSeries({
				color: '#f17b00',
				name: this.DateRangeService.compareStartDate.format('DD/MM/YYYY') + ' - ' + this.DateRangeService.compareEndDate.format('DD/MM/YYYY'),
				data: data
			});
		} else {
			// Otherwise update compare date range series
			this.$overviewElement.series[1].update({
				name: this.DateRangeService.compareStartDate.format('DD/MM/YYYY') + ' - ' + this.DateRangeService.compareEndDate.format('DD/MM/YYYY'),
				data: data
			}, true);
		}
		this.$overviewElement.redraw();
		window.dispatchEvent(new Event('resize'));
	}

	updateBaseData(data) {
		let categories = [];
		let volume = [];

		let unknownCategoryFlag = false;
		let unknowCategory = null;
		let unknowCategoryVolume = null;

		this.baseData = data;

		for (let row of data) {
			let category = row[0];
			if (row[0] === null) {
				category = 'Unknown';
			}
			categories.push(category);
			volume.push(row[1]);
		}

		this.$element.xAxis[0].update({
			categories: categories
		}, true);

		this.$element.series[0].update({
			name: this.DateRangeService.startDate.format('DD/MM/YYYY') + ' - ' + this.DateRangeService.endDate.format('DD/MM/YYYY'),
			data: volume
		}, true);

		// If compare date range is unchecked
		if (!this.AppService.compare && this.$element.series.length == 2) {
			this.$element.series[1].remove(false);
		}

		if (this.chartType === 'bar') {
			let height = 80 + (this.baseData.length*40)
			this.$element.setSize(this.$element.renderTo.offsetWidth, height, true);
		}

		this.$element.redraw();
		window.dispatchEvent(new Event('resize'));
	}

	updateCompareData(data) {
		// Sorting algorithm
		if (data.length > 0) {
			if (isNaN(Date.parse(data[0][0]))) {
				// Sort
				let xList = data.map((value, index) => {
					return value[0];
				});

				let sortedData = [];

				// For over baseData
				for (let i = 0; i < this.baseData.length; i++) {
					let index = xList.indexOf(this.baseData[i][0]);
					if (index > -1) {
						sortedData.push(data[index]);
					} else {
						sortedData.push([this.baseData[i][0], 0]);
					}
				}
				this.compareData = sortedData;
			} else {
				this.compareData = data;
			}
		} else {
			this.compareData = data;
		}


		// Create new series only if chart element has only 1 series (base date range)
		if (this.$element.series.length == 1) {
			this.$element.addSeries({
				color: '#f17b00',
				name: this.DateRangeService.compareStartDate.format('DD/MM/YYYY') + ' - ' + this.DateRangeService.compareEndDate.format('DD/MM/YYYY'),
				data: this.compareData
			});
		} else {
			// Otherwise update compare date range series
			this.$element.series[1].update({
				name: this.DateRangeService.compareStartDate.format('DD/MM/YYYY') + ' - ' + this.DateRangeService.compareEndDate.format('DD/MM/YYYY'),
				data: this.compareData
			}, true);
		}
		this.$element.redraw();
		window.dispatchEvent(new Event('resize'));
	}

	reflow() {
		this.$element.reflow();
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/services/chart.service.js
 **/